import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

import './App.css';
import NavBar from './Components/NavBar';
import LawBase from './Components/LawBase';
import Contacts from './Components/Contacts';
import About from './Components/About';
import Footer from './Components/Footer';
import ISS from './Components/SearchWide/ISS';
import Review from './Components/SearchWide/Review/Review';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <>
          <NavBar />
          <Switch>
            <Route exact path="/mop/" component={About} />
            <Route path="/mop/search" component={ISS} />
            <Route path="/mop/review/:id" component={Review} />
            <Route path="/mop/lawbase" component={LawBase} />
            <Route path="/mop/contacts" component={Contacts} />
            <Route component={About} />
          </Switch>
          <Footer />
        </>
      </BrowserRouter>
    );
  }
}

export default App;
